
import DataMapper from '../DataMapper'
import TreatingDoctorRM from '../../responsemodel/ReportRM/TreatingDoctorRM'
import TreatingDoctor from '../../../models/ReportModels/TreatingDoctor'

export default class TreatingDoctorDataMapper extends DataMapper<TreatingDoctorRM, TreatingDoctor> {
    map = (rm: TreatingDoctorRM) => new TreatingDoctor(rm._id, rm.name, rm.mobile, rm.registrationNumber)
}
